import { useMemo } from 'react'
import { useLocation } from 'react-router'
import { getRouteParams, RouteParams } from 'routes/SpaceContextRoute'

export function useRouteParams(): RouteParams {
    const { pathname } = useLocation()
    return useMemo(() => getRouteParams(pathname), [pathname])
}
